<script>
  import AppLinks from "./AppLinks.svelte";
  import Rating from "./Rating.svelte";
  import SteamBanner from "./SteamBanner.svelte";
  import { format } from "date-fns";

  export let app = {};
  let id;
  let releaseDate = "";
  let genres = [];
  let tags = [];

  let positives = "";
  let negatives = "";

  $: {
    if (!!app && !!app.appId) {
      id = app.appId;
      releaseDate = !!app.releaseDate
        ? format(new Date(app.releaseDate * 1000), "Do MMMM YYYY")
        : "TBA";
      ({ genres, tags } = app);
    }
  }
</script>

<article class="app-summary">
  <h1>{app.name || ''}</h1>
  <aside>
    <figure>
      <SteamBanner {id} capsule={false} />
    </figure>
    <AppLinks {id} />
    <section class="ratings">
      <ul>
        <li>
          <Rating value={app.ratingCurrent}>RECENT</Rating>
        </li>
        <li>
          <Rating value={app.ratingOverall}>OVERALL</Rating>
        </li>
        <li>
          <Rating value={app.metascore}>METASCORE</Rating>
        </li>
      </ul>
    </section>
  </aside>
  <section class="description">
    <section>
      <h1>Release Date</h1>
      <p>{releaseDate}</p>
    </section>
    <section>
      <h1>Genre</h1>
      <ul class="genres">
        {#each genres || [] as genre}
          <li>{genre}</li>
        {/each}
      </ul>
    </section>
    <section>
      <h1>Tags</h1>
      <small>
        <ul class="tags">
          {#each tags || [] as tag}
            <li>{tag}</li>
          {/each}
        </ul>
      </small>
    </section>
  </section>
</article>
